import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverCallins extends Layout {
    labelDriverCallinHistory: Label;
    sourceDriverCallins: DataSource;
    sourceDriverOrder: DataSource;
    tableDriverCallins: Table;
}
